import {
  useDataVisibleChartState,
  type UseDataVisibleChartState,
  type UseDataVisibleChartStateOptions,
} from './useDataVisibleChartState'

export type UseChartConfigOptions = UseDataVisibleChartStateOptions
export type UseChartConfig = UseDataVisibleChartState

/** Public module-08 chart configuration seam for report-bearing feature consumers. */
export function useChartConfig(options: UseChartConfigOptions): UseChartConfig {
  return useDataVisibleChartState(options)
}
